import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import PropTypes from 'prop-types';

const TAGS_SHOWN_NUMBER = 4;
class ArticleTags extends React.Component {
  render() {
    const { tags, container } = this.props;

    // Sorting tags by is_primary, then title
    tags.sort((a, b) => {
      if (a.is_primary && !b.is_primary) {
        return -1;
      } else if (!a.is_primary && b.is_primary) {
        return 1;
      } else {
        return a.title.localeCompare(b.title);
      }
    });

    // If there are more than 4 tags, show the first 4 and the rest in a tooltip
    const visibleTags = tags.slice(0, TAGS_SHOWN_NUMBER);
    const hiddenTags = tags.slice(TAGS_SHOWN_NUMBER);
    const isModalContainer = container === 'modal';
    const Link = ({ id, children, tags }) => (
      <OverlayTrigger placement={isModalContainer ? 'bottom' : undefined} overlay={
        <Tooltip className='cs-tags-tooltip' bsPrefix={'text-left tooltip'} id={id}>
          <div className="cs-article-tags__tooltip">
            {tags.map((tag, index) => renderTag(tag, index + TAGS_SHOWN_NUMBER))}
          </div>
        </Tooltip>} trigger={'focus'}>
        <a href="javascript:void(0)">{children}</a>
      </OverlayTrigger>
    );

    const renderTag = (tag, index) => {
      if (tag.url) {
        return (
          <a
            key={index}
            href={tag.url}
            className="cs-article-tags__item"
            dangerouslySetInnerHTML={{ __html: tag.title }}
          />
        );
      }
      
      return (
        <span
          key={index}
          className="cs-article-tags__item"
          dangerouslySetInnerHTML={{ __html: tag.title }}
        />
      );
    };
    const showTooltip = tags.length > TAGS_SHOWN_NUMBER;
    return (
      <div className="cs-article-tags">
        {visibleTags.map((tag, index) => renderTag(tag, index))}
        {showTooltip && (
          <>
            { isModalContainer && <br /> }
            <Link id="cs-tags-tooltip" tags={hiddenTags}>
              <span className="cs-article-tags__item">+{hiddenTags.length} more</span>
            </Link>
          </>
        )}
      </div>
    );
  }
}

ArticleTags.propTypes = {
  id: PropTypes.string,
  children: PropTypes.element,
  tags: PropTypes.array.isRequired,
};

export default ArticleTags;
